// GradFlow config for the brand band (`.bl-hero`). Shared by Home and About so
// the two bands cannot drift apart.
//
// The three stops are palette colours: papaya (#e66b2c), light orange
// (#f89938), and a deepened papaya close to merlot (#b23415). Order matters the
// same way the static gradient it replaced did: the darkest stop has to reach
// the top of the band, because that is where the headline sits and the only
// place the off-white type clears contrast.
export const HERO_GRADFLOW_CONFIG = {
  color1: { r: 230, g: 107, b: 44 },
  color2: { r: 248, g: 153, b: 56 },
  color3: { r: 178, g: 52, b: 21 },
  speed: 1.3,
  scale: 1.2,
  type: "stripe",
  noise: 0.1,
};

// The band behind Top contributors on Home. Same canvas, deliberately not the
// same weather: this one is a recognition, not a call to act.
//
// `silk` rather than the hero's `stripe` -- broad soft sheets that drift across
// each other, which is the closest thing the library has to a polished surface
// catching the light. `stripe` reads as motion and urgency, which is the hero's
// job and would say the wrong thing under a leaderboard.
//
// Light orange leads, because it is the nearest the palette comes to gold, with
// papaya behind it and merlot as the anchor that keeps the darker half dark
// enough for the off-white heading to clear contrast. Half the hero's speed and
// a wider scale: a slow shimmer, not a current.
//
// GradFlow honours prefers-reduced-motion itself, and stops rendering offscreen
// and in hidden tabs, which matters here because this band is below the fold.
export const ACHIEVEMENT_GRADFLOW_CONFIG = {
  color1: { r: 230, g: 107, b: 44 },
  color2: { r: 248, g: 180, b: 56 },
  color3: { r: 178, g: 100, b: 21 },
  speed: 1,
  scale: 0.5,
  type: "smoke",
  noise: 0.08,
};
